export default {
  personNameMinLength: 2,
  companyNameMinLength: 3,
  passwordMinLength: 6,
  inlineError: {
    fieldRequired: '%s is required.',
    auth: {
      // signUp errors
      invalidFirstName: 'First name must be at least 2 characters.',
      invalidLastName: 'Last name must be at least 2 characters.',
      invalidEmail: 'Please enter a valid email.',
      invalidPhonenumber: 'Please enter a valid phonenumber.',
      invalidPassword: 'Password must be at least 6 characters.',
      invalidCompanyName: 'Company name must be at least 3 characters.',
      invalidRole: 'Role must either be admin or member only.',
      passwordsMismatched: "Password and confirm password didn't matched",
      invalid6DigitCode: 'Please enter a 6-digit code.'
    },
    profile: {
      // edit profile errors
      invalidDescription: 'Maximum characters for description was reached.'
    },
    listingForm: {
      lessThanZero: '%s must be greater than zero.'
    }
  },
  alertError: {
    generic: 'Something went wrong. Please try again later.',
    formInvalid:
      'One of the fields in the form has an invalid value. Please check and try again.',
    noCurrentPassword: 'Please enter your current password.',
    auth: {
      // signUp errors
      emailAlreadyUsed: 'The email you provided is already in used.',
      invalidEmail: 'The email you provided is invalid.',
      signInMethodNotAvailable:
        'This signin method is not enabled. Please use other signin method.',
      weakPassword:
        'The password you provided is too weak. Please enter at least 6 characters.',
      // signIn errors
      userDisabled:
        'Your account has been disabled. Please reach out to Support to reactivate your account.',
      incorrectEmailOrPassword: 'The supplied email or password is incorrect.',
      unregisteredAccount:
        'This account is not registered as a %s. Please sign in with a different email address.',
      incorrectPassword:
        'Your current password is not correct. Please enter the correct password.',
      emailInvited:
        'Your email was invited to another company account and was not verified.',
      authInvalidVerifyCode: 'The provided 6-digit code is invalid.',
      alreadySignedUp:
        'You are already signed up. Please login with your phone number.',
      authInvalidPhonenumber: 'Please provide a valid phone number.'
    },
    noWorkPermit: 'Please upload your work permit',
    editProfile: {
      currentPasswordIncorrect:
        'The current password you provided is incorrect.'
    },
    variantAlreadyExists:
      'Variant already added, please choose a new variant name',
    variantValuesMissing: 'One or more variant values are missing.',
    fetchingCategoriesError: 'Error fetching categories.',
    noVendorId: 'No vendor detected. Please log in as vendor.',
    listingForm: {
      imageFull: 'Image upload quota reached.',
      imageNotFound: 'Image not found!'
    },
    itemNotFound:
      'We are having trouble loading this product. Please select another product.',
    shop: {
      alreadyInCart: 'This item is already in your cart!',
      orderNotReady: 'Your order is not ready. Please try again later.',
      unknownStatus: 'Unknown order status. Please try again later.',
      paymentNotReady:
        'Payment is not available at the moment. Please try again after a few seconds.',
      paymentFailed:
        'There was an error processing your payment. Please try again with a different payment method.',
      shippingUnavailable:
        "This item doesn't ship to your address region. Please select a different address.",
      cannotAddMoreItems:
        'You may only buy one item at a time when paying in installments. To continue, please checkout first.'
    },
    noImageUploaded: 'Please upload an image.'
  },
  alertMessage: {
    docAdded: '%s has been added.',
    docUpdated: '%s has been updated.',
    docDeleted: '%s has been removed.',
    passwordUpdated: 'Password has been successfully updated.',
    uploadingImage: 'Uploading image...',
    uploadingDocument: 'Uploading document..',
    memberInvited: "An invitation has been sent to the member's email address",
    userDeleted: 'User successfully deleted.',
    addingListingItem: 'Creating item..',
    addingListingItemSuccessful: 'Created item!',
    updatingListingItem: 'Updating item..',
    updatingListingItemSuccessful: 'Updated!',
    addedToCart: 'Well done! You successfully added this item to your cart!',
    orderStatusUpdated: 'Order status has been updated!',
    orderCanceled: 'Order has been canceled!',
    paymentSuccessful: 'Your order has been successfully paid!',
    paymentReceived:
      'Your payment has been received and should be confirmed soon!',
    createGiftSuccessful: 'Your gift has been created!',
    createGiftBundleSuccessful: 'Your gift bundle has been created!',
    updateGiftSuccessful: 'Update gift successful!',
    updateGiftBundleSuccessful: 'Update gift bundle successful!',
    deleteGiftSuccessful: 'Gift deleted!',
    deleteGiftBundleSuccessful: 'Gift bundle deleted!',
    deliveryCountryChanged: 'Your delivery country was changed to %s'
  },
  stateMessages: {
    empty: 'There are no %s yet',
    noMatch: 'No matching %s'
  },
  homeCountries: [
    //'Malaysia',
    'Indonesia',
    'Philippines'
    // 'India',
    // 'Myanmar'
  ],
  workCountries: ['Singapore'],
  checkoutSteps: ['Cart', 'Details', /*'Shipping',*/ 'Review', 'Payment'],
  bigMochiBankAccountName: 'BigMochi Pte Ltd.',
  paymentMethod: {
    payNow: '202012225H',
    dash: '+6580304988'
  },
  deliveryRegions: {
    philippines: ['Metro Manila', 'Luzon', 'Visayas', 'Mindanao']
  },
  straightPayment: { month3: 0, month6: 0 },
  date: {
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
  },
  maxHoolahAmount: 850,
  jobs: [
    {
      id: '1',
      title: 'Domestic Worker',
      thumbUrl: '/jobs/home-keeper.PNG',
      link: 'https://contactus692272.typeform.com/to/Ig3ES4gi'
    },
    {
      id: '2',
      title: 'Foreign Worker',
      thumbUrl: '/jobs/nayaka.PNG',
      link: 'https://contactus692272.typeform.com/to/pia3Ab7A'
    }
  ]
}
